import type { IconProps } from '@fv/client-components'

import { TabLink } from '../TabLink'

type QuoteListFilterProps = {
  active: boolean
  icon: IconProps['icon']
  label: string
  onClick: () => void
}

export const QuoteListFilter = ({
  active,
  icon,
  label,
  onClick,
}: QuoteListFilterProps) => {
  return (
    <TabLink icon={icon} isActive={active} onClick={onClick}>
      {label}
    </TabLink>
  )
}
